export default "__VITE_ASSET__C8dGYx5C__"